module.exports = __webpack_public_path__ + "img/home01.0a0b4e2c.svg";